import Modal from "react-bootstrap/Modal";
import { FaFilePdf, FaFileImage, FaFileAlt } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";


function QueriesDocumentPop(props) {
  const { handleClose, selectedDoc = [] } = props;

  // Helper to determine icon based on file extension
  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
      return <FaFileImage size={40} color="#4caf50" />;
    } else if (["pdf"].includes(extension)) {
      return <FaFilePdf size={40} color="#f44336" />;
    } else {
      return <FaFileAlt size={40} color="#2196f3" />;
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      size="md"
      keyboard={false}
      centered
      className="wellness-video-modal-box"
    >
      <Modal.Header className="queries-document-popup-header">
        <Modal.Title className="wellness-video-title">
          Uploaded Documents
        </Modal.Title>
        <button variant="secondary" className="queries-doc-close-btn" onClick={handleClose}>
          <IoCloseCircleOutline/>
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="uploaded-documents-container">
          {selectedDoc?.length === 0 ? (
            <p className="text-muted text-center">No documents uploaded.</p>
          ) : (
            <div className="document-grid">
              {selectedDoc?.map((doc, index) => (
                <a
                  href={doc.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  className="document-card"
                >
                  <div className="document-icon">
                    {getFileIcon(doc.file_name)}
                  </div>
                  <div className="document-name">{doc.original_file_name}</div>
                </a>
              ))}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default QueriesDocumentPop;
